import styled from 'styled-components';

export const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9998;
`;

export const Container = styled.div`
  width: 450px;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 40px 40px 30px 40px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  color: #bf3939;
`;

export const Message = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #98a2b3;

  b {
    font-weight: 700;
    color: #475466;
  }
`;

export const ListContainer = styled.ul`
  border-bottom: 1px solid #e4e9f0;
  padding-bottom: 20px;

  li {
    margin-left: 35px;
    list-style-type: disc;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    color: #98a2b3;
  }
`;

export const Button = styled.button`
  border: 0;
  background: #4a90e2;
  border-radius: 50px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  max-width: 125px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
